import { urlLinkData } from "./urlLinkData";

const pagesData = [
  {
    title: "Home",
    key: "home",
    icon: "home",
    link: urlLinkData.home,
  },
  {
    title: "Blog",
    key: "blog",
    icon: "home",
    link: urlLinkData.blog,
  },
  {
    title: "Link Tree",
    key: "link-tree",
    icon: "home",
    link: urlLinkData.linkTree,
  },
  {
    title: "Coach",
    key: "coach",
    icon: "home",
    link: urlLinkData.coach,
  },
];

export default pagesData;
